import { render, staticRenderFns } from "./OwnersBookings.vue?vue&type=template&id=87ac7646&"
import script from "./OwnersBookings.vue?vue&type=script&lang=js&"
export * from "./OwnersBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports